<template>
  <div>
    <!-- Market Data Row -->
    <div class="bg-[#00365f] w-full flex justify-center">
      <div class="market-ticker-shell flex min-h-[34px] items-center gap-[18px] sm:gap-[34px] max-w-[1240px] w-full mx-auto overflow-hidden px-[12px] sm:px-[24px] lg:px-0">
        <div class="flex gap-[5px] items-center justify-center px-[8px] py-[3px] rounded-[6px] shrink-0">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 16V21" stroke="#B8BEC8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 14.639V21" stroke="#B8BEC8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20 10.656V21" stroke="#B8BEC8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22 3L13.354 11.646C13.3076 11.6926 13.2524 11.7295 13.1916 11.7547C13.1309 11.7799 13.0658 11.7929 13 11.7929C12.9342 11.7929 12.8691 11.7799 12.8084 11.7547C12.7476 11.7295 12.6924 11.6926 12.646 11.646L9.354 8.354C9.26024 8.26026 9.13308 8.20761 9.0005 8.20761C8.86792 8.20761 8.74076 8.26026 8.647 8.354L2 15" stroke="#B8BEC8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4 18.463V21" stroke="#B8BEC8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 14.656V21" stroke="#B8BEC8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <p class="font-bold text-[#f5f7fb] text-[13px] leading-none whitespace-nowrap">오늘의 거래 기준가</p>
        </div>
        <!-- 시세는 오른쪽에서 왼쪽으로 흐른다. 예전에는 이 파일 안의 CSS 로 모바일에서만
             흐르게 해 두었다. 상단이 세 사이트 모두 같아야 하므로 공용 RatesTicker 로 바꾸고
             화면 폭과 상관없이 흐르게 한다. 몇 벌을 이어 붙일지는 RatesTicker 가 재서 정한다. -->
        <RatesTicker class="min-w-0 flex-1" :items="tickerItems" :gap="34">
          <template #default="{ item }">
            <p class="font-semibold text-[#f5f7fb] text-[13px] leading-none whitespace-nowrap">{{ item.label }}</p>
            <p class="ml-[6px] font-bold text-white text-[13px] leading-none whitespace-nowrap">{{ item.price }}</p>
            <div class="ml-[6px] flex gap-[3px] items-center shrink-0" :class="item.direction === 'up' ? 'text-[#00c88a]' : 'text-[#ff4057]'">
              <svg v-if="item.direction === 'up'" width="8" height="7" viewBox="0 0 12 9" fill="none"><polygon points="6,0 12,9 0,9" fill="currentColor" /></svg>
              <svg v-else width="8" height="7" viewBox="0 0 12 9" fill="none"><polygon points="0,0 12,0 6,9" fill="currentColor" /></svg>
              <p class="text-[12px] leading-none whitespace-nowrap">({{ item.change }})</p>
            </div>
          </template>
        </RatesTicker>
      </div>
    </div>

    <div class="relative border-b border-[#d7dde6] bg-[#f3f5f8]">
      <button
        type="button"
        class="mx-auto flex h-[28px] w-full max-w-[1240px] items-center justify-center gap-[6px] px-[16px] text-center text-[12px] font-semibold text-[#3f4b5f] hover:text-[#202632]"
        @click.stop="toggleRatesLayer"
      >
        <span class="text-[9px]" :class="ratesLayerVisible ? 'rotate-180' : ''">▲</span>
        <span>오늘의 금 · 은 · 백금 중매시세</span>
        <span class="text-[9px]" :class="ratesLayerVisible ? 'rotate-180' : ''">▲</span>
      </button>

      <div
        v-if="ratesLayerVisible"
        class="rates-layer left-0 top-full z-30 w-full border-t border-[#d7dde6] bg-white shadow-[0_16px_28px_rgba(15,23,42,0.12)]"
        @click.stop
      >
        <div class="mx-auto w-full max-w-[1240px] overflow-x-auto px-[16px] py-[12px] lg:px-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <div class="hidden min-w-[760px] rounded-[10px] border border-[#dfe4ec] bg-white shadow-[0_10px_24px_rgba(15,23,42,0.08)] sm:block">
            <div class="grid grid-cols-[1.1fr_1fr_1fr] items-center border-b border-[#e5e7eb] px-[18px] py-[12px]">
              <div>
                <p class="text-[13px] font-bold text-[#202632]">오늘의 금 · 은 · 백금 시세</p>
                <p class="mt-[3px] text-[12px] text-[#8a8f99]">2026.06.06 기준</p>
              </div>
              <p class="text-center text-[13px] font-semibold text-[#48566a]">내가 살 때 <span class="font-normal text-[#8a8f99]">(위탁 중매 기준)</span></p>
              <p class="text-center text-[13px] font-semibold text-[#48566a]">내가 팔 때 <span class="font-normal text-[#8a8f99]">(위탁 중매 기준)</span></p>
            </div>

            <div
              v-for="row in ratesTable"
              :key="row.name"
              class="grid grid-cols-[1.1fr_1fr_1fr] items-center border-b border-[#edf0f4] px-[18px] py-[12px] last:border-b-0"
            >
              <div>
                <p class="text-[14px] font-bold text-[#202632]">{{ row.name }}</p>
                <p class="mt-[3px] text-[12px] text-[#8a8f99]">{{ row.label }}</p>
              </div>
              <div class="flex items-baseline justify-center gap-[8px]">
                <p class="text-[16px] font-bold text-[#111827]">{{ row.buyPrice || '제품시세적용' }}</p>
                <p v-if="row.buyChange" class="text-[12px] text-[#2b8ee8]">{{ row.buyChange }}</p>
              </div>
              <div class="flex items-baseline justify-center gap-[8px]">
                <p class="text-[16px] font-bold text-[#111827]">{{ row.sellPrice }}</p>
                <p class="text-[12px] text-[#2b8ee8]">{{ row.sellChange }}</p>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-[8px] sm:hidden">
            <div class="rounded-[10px] border border-[#dfe4ec] bg-white p-[14px]">
              <p class="text-[13px] font-bold text-[#202632]">오늘의 금 · 은 · 백금 시세</p>
              <p class="mt-[3px] text-[12px] text-[#8a8f99]">2026.06.06 기준</p>
            </div>
            <div
              v-for="row in ratesTable"
              :key="row.name"
              class="rounded-[10px] border border-[#edf0f4] bg-white p-[14px]"
            >
              <div class="flex items-start justify-between gap-[12px]">
                <div>
                  <p class="text-[14px] font-bold text-[#202632]">{{ row.name }}</p>
                  <p class="mt-[2px] text-[12px] text-[#8a8f99]">{{ row.label }}</p>
                </div>
                <div class="text-right">
                  <p class="text-[12px] text-[#8a8f99]">팔 때</p>
                  <p class="text-[15px] font-bold text-[#111827]">{{ row.sellPrice }}</p>
                  <p class="text-[12px] text-[#2b8ee8]">{{ row.sellChange }}</p>
                </div>
              </div>
              <div class="mt-[10px] rounded-[8px] bg-[#f6f8fb] px-[12px] py-[9px]">
                <p class="text-[12px] text-[#8a8f99]">살 때</p>
                <div class="mt-[3px] flex items-baseline justify-between gap-[8px]">
                  <p class="text-[15px] font-bold text-[#111827]">{{ row.buyPrice || '제품시세적용' }}</p>
                  <p v-if="row.buyChange" class="text-[12px] text-[#2b8ee8]">{{ row.buyChange }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="bg-white border-[#e0e0e0] border-b border-t border-solid w-full flex flex-col items-center">
      <div class="flex items-center justify-between max-w-[1240px] w-full mx-auto px-[16px] lg:px-0">
        <button
          type="button"
          class="lg:hidden flex items-center justify-center size-[44px] shrink-0"
          aria-label="메뉴 열기"
          @click="mobileMenuOpen = !mobileMenuOpen"
        >
          <svg class="size-[24px] text-[#3a4250]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path v-if="!mobileMenuOpen" d="M3 6h18M3 12h18M3 18h18" stroke-linecap="round" />
            <path v-else d="M6 6l12 12M18 6L6 18" stroke-linecap="round" />
          </svg>
        </button>
        <div class="hidden lg:flex gap-[10px] h-[64px] items-center shrink-0">
          <router-link to="/" aria-label="홈" class="flex h-full items-center justify-center px-[14px] shrink-0 text-[#5f6673] hover:text-[#d9a72e]">
            <svg class="size-[20px]" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 19V12.1528C7 11.5226 7.53726 11.0116 8.2 11.0116H11.8C12.4627 11.0116 13 11.5226 13 12.1528V19M9.30457 1.21117L1.50457 6.48603C1.18802 6.7001 1 7.04665 1 7.41605V17.2882C1 18.2336 1.80589 19 2.8 19H17.2C18.1941 19 19 18.2336 19 17.2882V7.41605C19 7.04665 18.812 6.70011 18.4954 6.48603L10.6954 1.21117C10.2791 0.92961 9.72092 0.929609 9.30457 1.21117Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </router-link>
          <div class="border-b-2 border-transparent border-solid flex h-full items-center justify-center px-[20px] shrink-0 hover:border-[#d9a72e]">
            <p class="text-[#5f6673] text-[16px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors">회사소개</p>
          </div>
          <div class="border-b-2 border-transparent border-solid flex h-full items-center justify-center px-[20px] shrink-0 hover:border-[#d9a72e]">
            <p class="text-[#5f6673] text-[16px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors">REAL GOLD ASSET</p>
          </div>
          <router-link to="/b2b/products" class="border-b-2 border-transparent border-solid flex h-full items-center justify-center px-[20px] shrink-0 hover:border-[#d9a72e]">
            <p class="text-[#5f6673] text-[16px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors">B2B 특가</p>
          </router-link>
          <a :href="mediaHubUrl" class="border-b-2 border-transparent border-solid flex h-full items-center justify-center px-[20px] shrink-0 hover:border-[#d9a72e]">
            <p class="text-[#5f6673] text-[16px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors">미디어 허브</p>
          </a>
          <div class="border-b-2 border-transparent border-solid flex h-full items-center justify-center px-[20px] shrink-0 hover:border-[#d9a72e]">
            <p class="text-[#5f6673] text-[16px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors">지점안내</p>
          </div>
          <div class="border-b-2 border-transparent border-solid flex h-full items-center justify-center px-[20px] shrink-0 hover:border-[#d9a72e]">
            <p class="text-[#5f6673] text-[16px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors">REAL GOLD TRADE</p>
          </div>
        </div>
        <div class="flex gap-[8px] sm:gap-[16px] items-center shrink-0 py-[10px] lg:py-0">
          <div v-if="false" class="hidden sm:flex items-center shrink-0">
            <template v-for="(lang, idx) in languageFlags" :key="lang.code">
              <div class="flex gap-[10px] h-[44px] items-center justify-center px-[8px] lg:px-[16px] rounded-[8px] shrink-0">
                <img :src="lang.image" :alt="lang.code" class="h-[24px] w-[34px] rounded-[4px] object-cover shrink-0" />
              </div>
              <div v-if="idx < languageFlags.length - 1" class="bg-[#d7d7d7] h-[16px] w-px shrink-0"></div>
            </template>
          </div>
          <button
            v-if="isLoggedIn"
            type="button"
            class="hidden sm:flex items-center justify-center px-[12px] py-[6px] text-[#5f6673] text-[14px] whitespace-nowrap hover:text-[#3e6fb3] transition-colors"
            @click="handleLogout"
          >
            {{ logoutLabel }}
          </button>
          <router-link
            v-if="isLoggedIn"
            to="/my/info"
            class="hidden sm:flex items-center justify-center px-[12px] py-[6px] text-[#5f6673] text-[14px] whitespace-nowrap hover:text-[#3e6fb3] transition-colors"
          >
            마이페이지
          </router-link>
          <router-link
            v-else
            to="/login"
            class="hidden sm:flex items-center justify-center px-[16px] py-[8px] rounded-[8px] bg-[#3e6fb3] text-white font-semibold text-[14px] whitespace-nowrap hover:bg-[#345d99] transition-colors"
          >
            {{ loginLabel }}
          </router-link>
          <router-link
            v-if="isLoggedIn"
            to="/my/info"
            aria-label="마이페이지"
            class="inline-flex sm:hidden items-center justify-center"
          >
            <svg class="size-[24px] text-[#3a4250]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M20 21a8 8 0 0 0-16 0" stroke-linecap="round" stroke-linejoin="round" />
              <circle cx="12" cy="7" r="4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </router-link>
          <router-link to="/cart" aria-label="장바구니" class="relative inline-flex items-center justify-center">
            <svg class="size-[24px] text-[#3a4250]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span
              v-if="cartBadgeCount > 0"
              class="absolute -right-[9px] -top-[9px] flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#d9a72e] px-[5px] text-[11px] font-bold leading-none text-white shadow-[0_2px_8px_rgba(217,167,46,0.45)]"
            >
              {{ cartBadgeLabel }}
            </span>
          </router-link>
          <button type="button" aria-label="검색" class="inline-flex items-center justify-center" @click="searchOpen = true">
            <svg class="size-[24px] text-[#3a4250]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.3-4.3" stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </div>
      <div v-show="mobileMenuOpen" class="mobile-main-menu lg:hidden w-full border-t border-[#e0e0e0] border-solid bg-white">
        <div class="flex flex-col w-full">
          <p class="text-[#5f6673] text-[16px] px-[20px] py-[14px] border-b border-[#f0f0f0] border-solid">회사소개</p>
          <p class="font-bold text-[#d9a72e] text-[16px] px-[20px] py-[14px] border-b border-[#f0f0f0] border-solid">REAL GOLD ASSET</p>
          <router-link
            to="/b2b/products"
            class="text-[#5f6673] text-[16px] px-[20px] py-[14px] border-b border-[#f0f0f0] border-solid"
            @click="mobileMenuOpen = false"
          >
            B2B 특가
          </router-link>
          <a :href="mediaHubUrl" class="text-[#5f6673] text-[16px] px-[20px] py-[14px] border-b border-[#f0f0f0] border-solid">미디어 허브</a>
          <p class="text-[#5f6673] text-[16px] px-[20px] py-[14px] border-b border-[#f0f0f0] border-solid">지점안내</p>
          <p class="text-[#5f6673] text-[16px] px-[20px] py-[14px] border-b border-[#f0f0f0] border-solid">REAL GOLD TRADE</p>
          <router-link
            v-if="isLoggedIn"
            to="/my/info"
            class="text-[#5f6673] text-[16px] px-[20px] py-[14px] border-b border-[#f0f0f0] border-solid"
            @click="mobileMenuOpen = false"
          >
            마이페이지
          </router-link>
          <button
            v-if="isLoggedIn"
            type="button"
            class="text-left text-[#3e6fb3] font-semibold text-[16px] px-[20px] py-[14px]"
            @click="handleLogout"
          >
            {{ logoutLabel }}
          </button>
          <router-link
            v-else
            to="/login"
            class="text-[#3e6fb3] font-semibold text-[16px] px-[20px] py-[14px]"
          >
            {{ loginLabel }}
          </router-link>
        </div>
      </div>
    </div>

    <!-- Sub Navigation -->
    <div
      ref="categoryNav"
      :class="[
        'w-full flex justify-center border-b transition-[background-color,box-shadow,border-color] duration-200',
        categoryPinned
          ? 'fixed left-0 top-0 z-40 border-[#dfe4ec] bg-white/82 shadow-[0_10px_24px_rgba(0,38,77,0.10)] backdrop-blur-md'
          : 'bg-[#f4f7fa] border-[#dfe4ec]',
      ]"
    >
      <div class="relative flex items-center gap-[6px] max-w-[1240px] w-full mx-auto px-[12px] py-[7px] pb-[11px] sm:gap-[8px] sm:px-[16px] sm:py-[9px] sm:pb-[13px] lg:px-0">
        <button
          v-if="showCategoryScrollControls"
          type="button"
          :class="[
            'h-[30px] w-[30px] shrink-0 rounded-full text-[18px] leading-none shadow-sm transition sm:h-[34px] sm:w-[34px] sm:text-[20px]',
            canScrollCategoryLeft
              ? 'bg-[#00284a] text-white hover:bg-[#1f3f68]'
              : 'pointer-events-none bg-[#d8e0ea] text-[#8a95a6]',
          ]"
          aria-label="이전 카테고리"
          @click="scrollCategoryNav(-1)"
        >
          ‹
        </button>
        <div
          ref="categoryScroller"
          class="category-scroll-track flex flex-1 items-center gap-[8px] overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          @scroll="updateCategoryScrollState"
          @wheel="handleCategoryWheel"
        >
        <router-link
          to="/products"
          :class="[
            'category-nav-item flex items-center justify-center px-[10px] py-[4px] shrink-0 sm:px-[14px] sm:py-[5px]',
            isAllProductsActive ? 'is-active' : '',
          ]"
        >
          <p
            :class="[
              'font-semibold text-[13px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors sm:text-[15px]',
              isAllProductsActive ? 'text-[#111827]' : 'text-[#00284a]',
            ]"
          >
            {{ allProductsLabel }}
          </p>
        </router-link>
        <router-link
          v-for="label in productLabels"
          :key="label.productLabelCode"
          :to="{ path: '/products', query: { label: label.labelKey } }"
          :class="[
            'category-nav-item flex items-center justify-center px-[10px] py-[4px] shrink-0 sm:px-[14px] sm:py-[5px]',
            isLabelActive(label.labelKey) ? 'is-active' : '',
          ]"
        >
          <p
            :class="[
              'font-semibold text-[13px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors sm:text-[15px]',
              isLabelActive(label.labelKey) ? 'text-[#111827]' : 'text-[#00284a]',
            ]"
          >
            {{ label.badgeText || label.labelName }}
          </p>
        </router-link>
        <router-link
          v-for="category in productCategories"
          :key="category.categoryCode"
          :to="{ path: '/products', query: { category: category.categoryCode } }"
          :class="[
            'category-nav-item flex items-center justify-center px-[10px] py-[4px] shrink-0 sm:px-[14px] sm:py-[5px]',
            isCategoryActive(category.categoryCode) ? 'is-active' : '',
          ]"
        >
          <p
            :class="[
              'font-semibold text-[13px] whitespace-nowrap hover:font-bold hover:text-[#d9a72e] transition-colors sm:text-[15px]',
              isCategoryActive(category.categoryCode) ? 'text-[#111827]' : 'text-[#00284a]',
            ]"
          >
            {{ category.categoryName }}
          </p>
        </router-link>
        </div>
        <button
          v-if="showCategoryScrollControls"
          type="button"
          :class="[
            'h-[30px] w-[30px] shrink-0 rounded-full text-[18px] leading-none shadow-sm transition sm:h-[34px] sm:w-[34px] sm:text-[20px]',
            canScrollCategoryRight
              ? 'bg-[#00284a] text-white hover:bg-[#1f3f68]'
              : 'pointer-events-none bg-[#d8e0ea] text-[#8a95a6]',
          ]"
          aria-label="다음 카테고리"
          @click="scrollCategoryNav(1)"
        >
          ›
        </button>
        <div
          v-if="showCategoryScrollControls"
          class="absolute bottom-[5px] left-[58px] right-[58px] h-[2px] overflow-hidden rounded-full bg-[#d5dde8]"
        >
          <span
            class="block h-full rounded-full bg-[#00284a] transition-[width,transform] duration-150"
            :style="{
              width: `${categoryScrollThumbWidth}%`,
              transform: `translateX(${categoryScrollThumbLeft}%)`,
            }"
          ></span>
        </div>
      </div>
    </div>
    <div v-if="categoryPinned" class="h-[56px]"></div>
  </div>
  <div v-if="searchOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-[18px]" @click.self="searchOpen = false">
    <form class="w-full max-w-[460px] rounded-[16px] bg-white p-[24px] shadow-xl" @submit.prevent="submitSearch">
      <div class="flex items-center justify-between gap-[12px]">
        <h2 class="text-[20px] font-bold text-[#202632]">상품 검색</h2>
        <button type="button" class="text-[#8a8f99]" @click="searchOpen = false">닫기</button>
      </div>
      <input
        v-model.trim="searchKeyword"
        type="search"
        class="mt-[18px] h-[48px] w-full rounded-[8px] border border-[#d0d5dd] px-[14px] outline-none focus:border-[#3e6fb3]"
        placeholder="검색어를 입력하세요"
        autofocus
      />
      <button type="submit" class="mt-[14px] h-[46px] w-full rounded-[8px] bg-[#202632] text-[15px] font-bold text-white">검색</button>
    </form>
  </div>
</template>

<script>
import korFlag from '@/assets/img/header/kor.png'
import engFlag from '@/assets/img/header/eng.png'
import chiFlag from '@/assets/img/header/chi.png'
import { getCategories } from '@/api/categories'
import { getProductLabels } from '@/api/products'
import { useAuthStore } from '@/stores/auth'
import { useCartStore } from '@/stores/cart'
import RatesTicker from '@/components/common/RatesTicker.vue'

export default {
  name: 'AppHeader',
  components: { RatesTicker },
  setup() {
    const authStore = useAuthStore()
    const cartStore = useCartStore()
    return { authStore, cartStore }
  },
  data() {
    return {
      mobileMenuOpen: false,
      languageFlags: [
        { code: 'KOR', image: korFlag },
        { code: 'ENG', image: engFlag },
        { code: 'CHI', image: chiFlag },
      ],
      productCategories: [],
      productLabels: [],
      searchOpen: false,
      searchKeyword: '',
      ratesLayerVisible: false,
      categoryPinned: false,
      categoryNavOffsetTop: 0,
      showCategoryScrollControls: false,
      canScrollCategoryLeft: false,
      canScrollCategoryRight: false,
      categoryScrollThumbWidth: 100,
      categoryScrollThumbLeft: 0,
      tickerItems: [
        { label: 'Gold', price: '951,000원', change: '-14,000', direction: 'down' },
        { label: 'Silver', price: '14,490원', change: '+690', direction: 'up' },
        { label: '중매거래', price: '951,000원', change: '-14,000', direction: 'down' },
        { label: '즉시거래', price: '951,000원', change: '-14,000', direction: 'down' },
      ],
      ratesTable: [
        { name: '순금시세', label: 'Gold 24k 3.75g', buyPrice: '922,500원', buyChange: '-13,600원', sellPrice: '902,700원', sellChange: '-13,300원' },
        { name: '18K 금시세', label: 'Gold 18k 3.75g', buyPrice: '', buyChange: '', sellPrice: '663,500원', sellChange: '-9,800원' },
        { name: '14K 금시세', label: 'Gold 14k 3.75g', buyPrice: '', buyChange: '', sellPrice: '514,500원', sellChange: '-7,600원' },
        { name: '백금시세', label: 'Platinum 3.75g', buyPrice: '376,000원', buyChange: '-17,000원', sellPrice: '368,000원', sellChange: '-17,000원' },
        { name: '은시세', label: 'Silver 3.75g', buyPrice: '14,100원', buyChange: '-600원', sellPrice: '13,800원', sellChange: '-600원' },
      ],
    }
  },
  mounted() {
    this.fetchCategories()
    this.fetchProductLabels()
    document.addEventListener('click', this.closeRatesLayer)
    window.addEventListener('scroll', this.updateCategoryPinned, { passive: true })
    window.addEventListener('resize', this.handleHeaderResize)
    this.$nextTick(this.handleHeaderResize)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeRatesLayer)
    window.removeEventListener('scroll', this.updateCategoryPinned)
    window.removeEventListener('resize', this.handleHeaderResize)
  },
  watch: {
    '$route.fullPath'() {
      this.syncCategoryScroll()
    },
    productCategories() {
      this.syncCategoryScroll()
    },
    productLabels() {
      this.syncCategoryScroll()
    },
  },
  computed: {
    allProductsLabel() {
      return '\uC804\uCCB4\uC0C1\uD488'
    },
    loginLabel() {
      return '\uB85C\uADF8\uC778'
    },
    logoutLabel() {
      return '\uB85C\uADF8\uC544\uC6C3'
    },
    selectedCategoryCodes() {
      const raw = this.$route.query.categories || this.$route.query.categoryCodes || this.$route.query.category || ''
      return String(raw)
        .split(',')
        .map(code => code.trim())
        .filter(Boolean)
    },
    selectedLabelKey() {
      return String(this.$route.query.label || this.$route.query.labelKey || '').trim()
    },
    isAllProductsActive() {
      return this.$route.path === '/products' && this.selectedCategoryCodes.length === 0 && !this.selectedLabelKey
    },
    cartBadgeCount() {
      return this.cartStore.items.reduce((sum, item) => sum + Number(item.qty || 0), 0)
    },
    cartBadgeLabel() {
      return this.cartBadgeCount > 99 ? '99+' : String(this.cartBadgeCount)
    },
    isLoggedIn() {
      return this.authStore.isLoggedIn
    },
    mediaHubUrl() {
      return import.meta.env.VITE_MEDIAHUB_URL || '/'
    },
  },
  methods: {
    toggleRatesLayer() {
      this.ratesLayerVisible = !this.ratesLayerVisible
      this.$nextTick(this.handleHeaderResize)
    },
    closeRatesLayer() {
      if (!this.ratesLayerVisible) return
      this.ratesLayerVisible = false
      this.$nextTick(this.handleHeaderResize)
    },
    handleHeaderResize() {
      this.resetCategoryNavPosition()
      this.syncCategoryScroll()
    },
    resetCategoryNavPosition() {
      this.categoryPinned = false
      this.$nextTick(() => {
        const nav = this.$refs.categoryNav
        this.categoryNavOffsetTop = nav ? nav.getBoundingClientRect().top + window.scrollY : 0
        this.updateCategoryPinned()
      })
    },
    updateCategoryPinned() {
      if (!this.categoryNavOffsetTop) return
      this.categoryPinned = window.scrollY > this.categoryNavOffsetTop
    },
    updateCategoryScrollState() {
      const scroller = this.$refs.categoryScroller
      if (!scroller) {
        this.showCategoryScrollControls = false
        this.canScrollCategoryLeft = false
        this.canScrollCategoryRight = false
        return
      }

      const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth
      this.showCategoryScrollControls = maxScrollLeft > 2
      this.canScrollCategoryLeft = scroller.scrollLeft > 2
      this.canScrollCategoryRight = scroller.scrollLeft < maxScrollLeft - 2
      this.categoryScrollThumbWidth = this.showCategoryScrollControls
        ? Math.max(16, (scroller.clientWidth / scroller.scrollWidth) * 100)
        : 100
      const movableTrack = 100 - this.categoryScrollThumbWidth
      const scrollRatio = maxScrollLeft > 0 ? scroller.scrollLeft / maxScrollLeft : 0
      this.categoryScrollThumbLeft = movableTrack > 0
        ? (scrollRatio * movableTrack * 100) / this.categoryScrollThumbWidth
        : 0
    },
    scrollCategoryNav(direction) {
      const scroller = this.$refs.categoryScroller
      if (!scroller) return

      scroller.scrollBy({
        left: direction * Math.max(260, Math.floor(scroller.clientWidth * 0.72)),
        behavior: 'smooth',
      })
      window.setTimeout(this.updateCategoryScrollState, 320)
    },
    handleCategoryWheel(event) {
      const scroller = this.$refs.categoryScroller
      if (!scroller || !this.showCategoryScrollControls) return

      const wheelDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY
      if (!wheelDelta) return

      event.preventDefault()
      scroller.scrollLeft += wheelDelta
      this.updateCategoryScrollState()
    },
    syncCategoryScroll() {
      this.$nextTick(() => {
        this.updateCategoryScrollState()
        this.scrollActiveCategoryIntoView()
      })
    },
    scrollActiveCategoryIntoView() {
      const scroller = this.$refs.categoryScroller
      if (!scroller) return

      const active = scroller.querySelector('.category-nav-item.is-active')
      if (!active) return

      const activeLeft = active.offsetLeft
      const activeRight = activeLeft + active.offsetWidth
      const visibleLeft = scroller.scrollLeft
      const visibleRight = visibleLeft + scroller.clientWidth

      if (activeLeft < visibleLeft || activeRight > visibleRight) {
        scroller.scrollTo({
          left: Math.max(0, activeLeft - Math.floor(scroller.clientWidth / 2) + Math.floor(active.offsetWidth / 2)),
          behavior: 'smooth',
        })
        window.setTimeout(this.updateCategoryScrollState, 320)
      }
    },
    handleLogout() {
      this.authStore.clearSession()
      this.mobileMenuOpen = false
      if (this.$route.meta.requiresAuth) {
        this.$router.replace('/')
      }
    },
    submitSearch() {
      if (!this.searchKeyword) return
      this.searchOpen = false
      this.$router.push({ path: '/products', query: { keyword: this.searchKeyword } })
      this.searchKeyword = ''
    },
    isCategoryActive(categoryCode) {
      return this.$route.path === '/products' && !this.selectedLabelKey && this.selectedCategoryCodes.includes(categoryCode)
    },
    isLabelActive(labelKey) {
      return this.$route.path === '/products' && this.selectedLabelKey === labelKey
    },
    async fetchCategories() {
      try {
        const res = await getCategories()
        if (res.data?.code === 0) {
          this.productCategories = res.data.categories || []
        }
      } catch (error) {
        this.productCategories = []
      }
    },
    async fetchProductLabels() {
      try {
        const res = await getProductLabels()
        this.productLabels = Array.isArray(res.data) ? res.data : []
      } catch (error) {
        this.productLabels = []
      }
    },
  },
}
</script>

<style scoped>
.rates-layer {
  position: absolute;
}

.mobile-main-menu {
  position: fixed;
  left: 0;
  right: 0;
  top: 90px;
  z-index: 45;
  max-height: calc(100vh - 90px);
  overflow-y: auto;
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.16);
}

@media (max-width: 639px) {
  .market-ticker-shell {
    min-height: 30px;
  }

  .rates-layer {
    position: static;
    box-shadow: none;
  }

  .category-scroll-track {
    gap: 14px;
  }
}

@media (min-width: 1024px) {
  .mobile-main-menu {
    position: static;
    box-shadow: none;
  }
}
</style>
